import { useEffect, useState } from "react";
import { useParams, NavLink,useHistory } from "react-router-dom";
import { getUser } from "../../http";

const Admin = () =>
{
    const [user,setUser] = useState({
        name:'',
        email:'',
        mobile:'',
        image:'',
        address:'',
        status:''
    });
    
    const navigate = useHistory();
    const {id} = useParams();

    const getUserData = async (id)=>{
        const res= await getUser(id);
        if(res.data.success)
            setUser(res.data.data);
    };


    useEffect(()=>{
        getUserData(id);
        // getUserJobDetails(id);
    },[id])


    return(
        <>
        <div className="main-content">
        <section className="section">
            <div className="section-header  d-flex justify-content-between">
                <h1>Admin</h1>
                <div>
                <button className="btn btn-danger mr-4 px-4" onClick={()=>{navigate.push("/admins")}}>Back</button>
                <NavLink to={`/edituser/${id}`} className='btn btn-primary'>Edit Admin</NavLink>
                </div>
            </div>
                <div className="card">
                  <div className="card-body row">
                    <div className="col-md-3 ">
                        <img className='img-fluid img-thumbnail' src={user.image} alt={user.name} />
                    </div>
                    <div className="col-md-9">
                       <table className='table'>
                            <tbody>
                                <tr>
                                    <th>Name</th>
                                    <td>{user.name}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>{user.email}</td>
                                </tr>
                                <tr>
                                    <th>Mobile</th>
                                    <td>+{user?.countryCode} {user.mobile}</td>
                                </tr>
                                <tr>
                                    <th>Address</th>
                                    <td>{user.address}</td>
                                </tr>
                                <tr>
                                    <th>Country</th>
                                    <td>{user.country}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
                </div>
        </section>
      </div>
      </>
    )
}

export default Admin;